<template>
  <div>
    <!--<div class="firstcolumn_tip">-->
    <!--&lt;!&ndash;<img :src="puxi" alt="">&ndash;&gt;-->
    <!--推荐谱系-->
    <!--</div>-->
    <div class="pushu_nav">
      <div class="columnBoxInnner">
        <div class="columnBoxInnnerList">
          <span v-for="(item,index) in puxiType" :key="index" :class="currentPuxi==index?'activenames':'names'" @click="gopushu(item,index)"><span class="span_name">{{ item.DICTIONARY_NAME }}</span><span v-if="index!=puxiType.length-1" style="margin: 0 8px;">/</span></span>
        </div>
      </div>
    </div>
    <div v-if="puxiData.length>0" class="center">
      <div v-for="(item,index) in puxiData" :key="index" class="puxi_content">
        <div class="libox">
          <div class="topColumnname" @click="goTree">
            谱系
          </div>
          <a class="imgbox" :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank">
            <img v-if="item.COVER" :src="item.COVER" alt="">
            <img v-else :src="noIMG" alt="">
          </a>
          <p>
            <span class="titlename">{{ item.SHOW_TITLE }}</span>
            <span class="hot_time">{{ item.CREATE_DATE }}</span>
            <span class="el-icon-view viewNumber">   {{ item.SHOW_READ_SIZE|changenum }}</span>
            <span class="viewNumber viewStar"><svg-icon icon-class="pinlun" />   {{ item.CONTENT_SPEAK_NUMBER|changenum }}</span>
          </p>
        </div>
      </div>
    </div>
    <div v-else style="text-align: center;font-size: 20px;color: #a19d9e;font-weight: 600;background-color: #ffffff;height: 150px;line-height: 150px;">
      暂无数据
    </div>
    <div class="addMore">
      <span class="addMore_span" @click="addMore">查看更多</span>
      <!--<span v-show="loadAll">已经到底了</span>-->
    </div>
  </div>
</template>
<script>
// ///首页列表模板上中下形式
import { getClassz, getDataTreeList } from '@/api/api.js'
export default {
  data() {
    return {
      noIMG: require('@/static/tree_default.png'),
      currerntPage: 1,
      currentType: '',
      loadAll: false,
      puxiData: [],
      puxiType: [{ DICTIONARY_ID: '', DICTIONARY_NAME: '最新推荐' }],
      currentPuxi: 0,
      puxi: require('@/static/puxi.png')
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.initType()
  },
  methods: {
    // /查询字典
    initType() {
      getClassz({ classCode: 'treeType' }).then(res => {
        this.puxiType = this.puxiType.concat(res.data)
        // console.log(res.data)
      })
    },
    initData() {
      getDataTreeList({ page: 1, limit: 4 }).then(res => {
        // console.log(res.data)
        this.puxiData = res.data.listMapData
        if (res.data.count <= 4) {
          this.loadAll = true
        }
      })
    },
    gopushu(names, index) {
      this.loadAll = false
      this.currerntPage = 1
      this.currentType = names.DICTIONARY_ID
      getDataTreeList({ page: 1, limit: 4, type: names.DICTIONARY_ID }).then(res => {
        this.puxiData = res.data.listMapData
        if (res.data.count <= 4) {
          this.loadAll = true
        }
      })
      this.currentPuxi = index
    },
    addMore() {
      this.$router.push({ path: '/treeList' })
      // this.currerntPage++
      // getDataTreeList({ page: this.currerntPage, limit: 4, type: this.currentType }).then(res => {
      //   this.puxiData = this.puxiData.concat(res.data.listMapData)
      //   if (res.data.page <= this.currerntPage) {
      //     this.loadAll = true
      //   }
      // })
    },
    goTree() {
      this.$router.push({ path: '/treeList' })
    },
    goDetail(sourceId, type) {
      const { href } = this.$router.resolve({
        url: '/sourceView',
        name: 'sourceView',
        query: {
          sourceId,
          type
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .firstcolumn_tip{
        margin-top: 20px;
        height: 68px;
        border: 1px solid #f0f0f0;
        text-align: center;
        line-height: 68px;
        background-color: #fff;
        img{
            width: auto;
            height: 29px;
            margin-top: 20px;
        }
    }
    .pushu_nav{
      height: 60px;
      line-height: 60px;
      background-color: #fff;
      text-align: center;
      margin-bottom: 20px;
      margin-top: 20px;
      span{
        font-size: 15px;
        color: #333333;
      }
      .names{
        .span_name{
          cursor: pointer;
          color: #333333;
          font-weight: 600;
          font-size: 16px;
        }
      }
      .activenames{
        .span_name{
          cursor: pointer;
          color: #ed4040;
          font-weight: 600;
          font-size: 16px;
        }
      }
    }
    .showlist{
        width: 1200px;
        overflow: hidden;
        font-size: 0;
        background-color: #fff;
        img{
            width: 1200px;
            height: 320px;
        }
        .lilist{
            position: relative;
            /*margin-top: 43px;*/
            display: inline-block;
            width: 162px;
            overflow: hidden;
            margin-left: 108px;
            img{
                width: 162px;
                height: 211px;
                cursor: pointer;
            }
            p{
                color: #333333;
                margin-top: 5px;
                font-size: 14px;
            }
            .tip{
                position: absolute;
                top: 7px;
                left: 9px;
                display: inline-block;
                width: 60px;
                background-color:rgba(0,0,0,.3);
                color: #ffffff;
                height: 20px;
                line-height: 20px;
                font-size: 12px;
                text-align: center;
                border-radius: 2px;
                cursor: pointer;
                &:hover{
                    color: #ed4040;
                }
            }
        }
    }
    .addMore{
      text-align: center;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      color: #999999;
      background-color: #fff;
      border: 1px solid #e5e5e5;
      border-radius: 3px;
      cursor: pointer;
      display:inline-block;
      width: 1198px;
      transition: 0.5s;
      margin-top: 20px;
      margin-bottom: 20px;
      &:hover{
        color: #ed4040;
        border: 1px solid #ed4040;
      }
    }
    .center{
        overflow: hidden;
        padding-bottom: 20px;
        .puxi_content{
          background-color: #fff;
            display: inline-block;
            margin-right: 33px;
            margin-top: 20px;
            width: 275px;
            height: 278px;
            transition: 0.3s;

            &:hover{
                transform: translate(0,-3px);
            }
            .libox{
                display: inline-block;
                width: 100%;
                font-size: 0;
                position: relative;
                .topColumnname{
                    text-align: center;
                    position: absolute;
                    top:10px;
                    left: 10px;
                  padding: 0 5px;
                    background-color:rgba(51,51,51,.5);
                    font-size: 12px;
                    color: #ffffff;
                    height: 18px;
                    line-height: 18px;
                    border-radius: 3px;
                    cursor: pointer;
                    &:hover{
                        background-color: rgba(237,64,64,.5);
                    }
                }
                .imgbox{
                    display: inline-block;
                    width: 275px;
                    height: 183px;
                    font-size: 0;
                    cursor: pointer;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                p{
                    width: 263px;
                    height: 93px;
                    border-left: 1px solid #f0f0f0;
                    border-right: 1px solid #f0f0f0;
                    border-bottom: 1px solid #f0f0f0;
                    -moz-box-shadow:1px 1px 3px #f3f3f3;
                    -webkit-box-shadow:1px 1px 3px #f3f3f3;
                    box-shadow:1px 1px 3px #f3f3f3;
                    text-align: left;
                    padding-left: 10px;
                    .titlename{
                        color: #333333;
                        font-size: 14px;
                        font-weight:500;
                        display: inline-block;
                        padding-top: 8px;
                        height:55px;
                        line-height: 25px;
                        width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .hot_time{
                        display: inline-block;
                        width: 155px;
                        height: 20px;
                        font-size: 12px;
                        color: #b2b2b2;
                    }
                    .viewNumber{
                        display: inline-block;
                        height: 20px;
                        width: 50px;
                        font-size: 12px;
                        color: #b2b2b2;
                        text-align:right;
                        svg{
                            vertical-align:middle;
                        }
                    }
                    .viewStar{
                        width: 50px;
                    }
                }
            }
        }
      .puxi_content:nth-child(4n){
        margin-right: 0;
      }
    }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .columnBoxInnner{
      width: 100%;
      overflow: hidden;
      padding-bottom: 20px;
      overflow-x: auto;
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
    }
    .center .puxi_content{
      display: block;
      margin: 0 auto 20px;
    }
  }
</style>
